import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee7a9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "merchant_actions_tutorial_modal",
  ref: "merchantActionsTutorialModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  style: {"max-width":"700px !important"}
}
const _hoisted_3 = { class: "modal-content p-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fs-2" }, "Merchant Actions"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1))
const _hoisted_5 = {
  class: "col-12 modal-body",
  style: {"min-height":"auto"}
}
const _hoisted_6 = { class: "timeline-item" }
const _hoisted_7 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"pe-3 mb-5\" data-v-3ee7a9ae><div class=\"fs-5 fw-boldest mb-2\" data-v-3ee7a9ae>Toolbar Menu</div><div class=\"d-flex\" data-v-3ee7a9ae><div class=\"text-gray-600 me-2 fs-5\" data-v-3ee7a9ae> Select the Merchant Actions menu on the top of the <span class=\"badge badge-primary p-3\" data-v-3ee7a9ae>/merchant/accounts/details</span></div></div></div>", 1)
const _hoisted_9 = { class: "overflow-hidden pb-5" }
const _hoisted_10 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded w-100 p-7" }
const _hoisted_11 = { class: "overlay me-10" }
const _hoisted_12 = { class: "overlay-wrapper" }
const _hoisted_13 = { class: "demo-image__preview" }
const _hoisted_14 = { class: "timeline-item" }
const _hoisted_15 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-3 mb-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-boldest mb-2" }, "Chargeback Actions"),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-1 fs-4 mb-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 me-2 fs-5" }, " All of the merchant actions are found by accessing the menu items: ")
  ])
], -1))
const _hoisted_17 = { class: "overflow-hidden" }
const _hoisted_18 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded w-100 p-7" }
const _hoisted_19 = { class: "overlay me-10" }
const _hoisted_20 = { class: "overlay-wrapper" }
const _hoisted_21 = { class: "demo-image__preview" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("API Sync")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Imports the current month of chargebacks automatically from payment processor. ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Upload File")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Uploads a list of chargebacks file from the payment processor. Specific chargeback file headers must match. ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Form")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Manually populate a single chargeback record for responding. Attach the original dispute notice (optional) ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pe-3 mb-0 mt-15" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-boldest mb-2" }, "Transaction Actions"),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-1 fs-4 mb-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 me-2 fs-5" }, " All of the merchants actions are found by accessing the transaction menu items: ")
  ])
], -1))
const _hoisted_29 = { class: "overflow-hidden pb-5" }
const _hoisted_30 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded w-100 p-7" }
const _hoisted_31 = { class: "overlay me-10" }
const _hoisted_32 = { class: "overlay-wrapper" }
const _hoisted_33 = { class: "demo-image__preview" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("API Sync")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Imports the current month of chargebacks automatically from payment processor. ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Upload File")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Uploads a list of chargebacks file from the payment processor. Specific chargeback file headers must match. ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Virtual Terminal")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Manually populate a single chargeback record for responding. Attach the original dispute notice (optional) ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_el_image, {
                          class: "rounded",
                          style: {"width":"50%"},
                          src: _ctx.url,
                          "preview-src-list": _ctx.srcList,
                          "initial-index": 0,
                          fit: "contain"
                        }, null, 8, ["src", "preview-src-list"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_el_image, {
                          class: "rounded center",
                          style: {"width":"80%"},
                          src: "https://devcrm.chargebacks.online/images/merchantactions_animation.gif",
                          "preview-src-list": _ctx.srcList,
                          "initial-index": 1,
                          fit: "contain"
                        }, null, 8, ["preview-src-list"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_el_descriptions, {
                column: 2,
                direction: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_el_image, {
                          class: "rounded center",
                          style: {"width":"80%"},
                          src: "https://devcrm.chargebacks.online/images/phpKqSILo20221109105731.png",
                          "preview-src-list": _ctx.srcList,
                          "initial-index": 1,
                          fit: "contain"
                        }, null, 8, ["preview-src-list"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_el_descriptions, {
                column: 2,
                class: "mt-3",
                direction: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, { size: "large" }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, null, {
                    default: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ], 512))
}